import { useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";

import Modal from "../Modal";

import VerificarUsuario from "../../helpers/usuario/verificarUsuario";
import obtener from "../../helpers/contribuyente/contribuyente/obtener";

/**
 * Componente padre de concesionario, con hijos: Contacto, Domicilio, Observaciones
 * @param {Object} param0 
 * @returns Componente React
 */
export default function Contacto({ catalogos, dataLoaded, data, setData }) {

    console.clear();
    VerificarUsuario();
    const { contribuyente } = data;
    const { pathname: path } = useLocation();
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [contribuyentes, setContribuyentes] = useState([]);

    const toggleModal = () => setModalIsOpen(!isModalOpen);

    return (
        <div className="contenedorMain">

            <div className="formulario">
                <div className="campoFormulario">
                    <div className="boxRow">

                        {/* Tipo de persona: (Física o Moral) */}
                        <div className="boxColumn flex1">
                            <label className="lblCampo">Tipo Persona</label>
                            <div className="boxRow">
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="pFisica" type="radio" name="tipoPersona" value="0"
                                            checked={!contribuyente?.tipoPersona ? true : contribuyente?.tipoPersona === 0}
                                            onChange={e => setData(
                                                {
                                                    ...data, contribuyente: {
                                                        ...contribuyente,
                                                        tipoPersona: Number(e.target.value),
                                                        rfc: contribuyente?.tipoPersona === 0 ?
                                                            contribuyente?.rfc.substring(0, 13) ?? "" : contribuyente?.rfc ?? ""
                                                    }
                                                })}
                                        />Física
                                    </span>
                                </div>

                                {/* Moral */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="pMoral" type="radio" name="tipoPersona" value="1"
                                            checked={contribuyente?.tipoPersona && contribuyente?.tipoPersona === 1}
                                            onChange={e => setData({
                                                ...data, contribuyente: {
                                                    ...contribuyente,
                                                    tipoPersona: Number(e.target.value),
                                                    rfc: contribuyente?.tipoPersona === 1 ?
                                                        contribuyente?.rfc.substring(0, 12) ?? "" : contribuyente?.rfc ?? ""
                                                }
                                            })}
                                        />Moral
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Género */}
                        <div className="boxColumn flex1">
                            <label className="lblCampo">Género</label>
                            <div className="boxRow">
                                {/* Hombre */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdHombre" type="radio" name="genero" value="2"
                                            checked={!contribuyente?.idGenero ? true : contribuyente?.idGenero === 2}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idGenero: Number(e.target.value) } })}
                                        />Hombre
                                    </span>
                                </div>

                                {/* Mujer */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdMujer" type="radio" name="genero" value="1"
                                            checked={contribuyente?.idGenero && contribuyente?.idGenero === 1}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idGenero: Number(e.target.value) } })}
                                        />Mujer
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* Estado civil */}
                        <div className="boxColumn flex2">
                            <label className="lblCampo">Estado Civil</label>
                            <div className="boxRow">
                                {/* Soltero */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdSoltero" type="radio" name="estadoCivil" value="0"
                                            checked={!contribuyente?.idEstadoCivil ? true : contribuyente?.idEstadoCivil === 0}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idEstadoCivil: Number(e.target.value) } })}
                                        />Soltero
                                    </span>
                                </div>

                                {/* Casado */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdCasado" type="radio" name="estadoCivil" value="1"
                                            checked={contribuyente?.idEstadoCivil && contribuyente?.idEstadoCivil === 1}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idEstadoCivil: Number(e.target.value) } })}
                                        />Casado
                                    </span>
                                </div>

                                {/* Unión libre */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdUnion" type="radio" name="estadoCivil" value="2"
                                            checked={contribuyente?.idEstadoCivil && contribuyente?.idEstadoCivil === 2}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idEstadoCivil: Number(e.target.value) } })}
                                        />Unión Libre
                                    </span>
                                </div>

                                {/* Sociedad conyugal */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdSociedad" type="radio" name="estadoCivil" value="3"
                                            checked={contribuyente?.idEstadoCivil && contribuyente?.idEstadoCivil === 3}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idEstadoCivil: Number(e.target.value) } })}
                                        />Sociedad Conyugal
                                    </span>

                                </div>

                                {/* Otro */}
                                <div>
                                    <span className="radio">
                                        <input className="radioBtn" id="rdOtro" type="radio" name="estadoCivil" value="4"
                                            checked={contribuyente?.idEstadoCivil && contribuyente?.idEstadoCivil === 4}
                                            onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idEstadoCivil: Number(e.target.value) } })}
                                        />Otro
                                    </span>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="boxRow">
                    {/* Id contribuyente */}
                    <div className="boxColumn">
                        <label className="lblCampo">Id</label>
                        <div className="search-bar-lbl">
                            <input type="text"
                                value={contribuyente?.idContribuyente === undefined ? "" : contribuyente?.idContribuyente}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idConcesionario: e.target.value.toUpperCase() } })}
                                disabled
                            />
                        </div>
                    </div>

                    {/* Nombre del contribuyente */}
                    <div className="boxColumn flex3" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                        <label className="lblCampo" id="lblContribuyente">Contribuyente</label>
                        <div className="search-bar">

                            {/* Nombre */}
                            <input className="actions" id="inputNombre" type="text" placeholder="Nombre(s)"
                                value={contribuyente?.nombre === undefined ? "" : contribuyente?.nombre.toUpperCase()}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, nombre: e.target.value.toUpperCase() } })}
                            />

                            {/* Apellido paterno */}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoP" type="text" placeholder="Apellido Paterno"
                                    value={contribuyente?.apellidoPaterno === undefined ? "" : contribuyente?.apellidoPaterno}
                                    onChange={e => setData({ ...data, contribuyente: { ...contribuyente, apellidoPaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Apellido materno */}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoM" type="text" placeholder="Apellido Materno"
                                    value={contribuyente?.apellidoMaterno === undefined ? "" : contribuyente?.apellidoMaterno}
                                    onChange={e => setData({ ...data, contribuyente: { ...contribuyente, apellidoMaterno: e.target.value.toUpperCase() } })}
                                />
                            )}
                            {/* Buscar */}
                            <div className="actions">
                                <button id="btn-abrir-popup" onClick={() => obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-icons">search</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Fecha de nacimiento */}
                    <div className="boxColumn">
                        <label className="lblCampo">Fecha Nacimiento</label>
                        <div className="search-bar">
                            <input type="date"
                                value={!contribuyente ? "" : contribuyente?.fechaNacimiento}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, fechaNacimiento: e.target.value } })}
                            />
                        </div>
                    </div>
                </div>

                <div className="boxRow">
                    {/* Nacionalidad */}
                    <div className="boxColumn flex1">
                        <label className="lblCampo">Nacionalidad</label>
                        <div className="search-bar">
                            <select id="selectNac"
                                value={contribuyente?.idNacionalidad === undefined ? 1 : contribuyente?.idNacionalidad}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idNacionalidad: Number(e.target.value) } })} >
                                {dataLoaded && catalogos?.nacionalidad.map(nacion =>
                                    <option defaultValue={nacion.idNacionalidad}
                                        key={nacion.idNacionalidad}
                                        value={nacion.idNacionalidad}>
                                        {nacion.nacionalidadNombre.toUpperCase()}
                                    </option>
                                )}
                            </select>
                        </div>
                    </div>

                    {/* Lugar de nacimiento */}
                    <div className="boxColumn flex1">
                        <label className="lblCampo">Lugar Nacimiento</label>
                        <div className="search-bar">
                            <select id="selectLugarN"
                                value={contribuyente?.idEstadoNacimiento === undefined ? 13 : contribuyente?.idEstadoNacimiento}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, idEstadoNacimiento: Number(e.target.value) } })} >
                                {dataLoaded && catalogos.estados.map(estado =>
                                    <option
                                        key={estado.idEstado}
                                        value={estado.idEstado}>
                                        {estado.nombre.toUpperCase()}
                                    </option>
                                )}
                            </select>
                        </div>
                    </div>

                    {/* RFC */}
                    <div className="boxColumn" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                        <label className="lblCampo">RFC</label>
                        <div className="search-bar">
                            <input className="actions" type="text" maxLength={contribuyente?.tipoPersona === 1 ? 12 : 13}
                                value={contribuyente?.rfc === undefined ? "" : contribuyente?.rfc}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, rfc: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions">
                                <button id="btn-abrir-popup" onClick={() => obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-icons">search</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* CURP */}
                    <div className="boxColumn">
                        <label className="lblCampo">CURP</label>
                        <div className="search-bar">
                            <input type="text" maxLength="18"
                                value={contribuyente?.curp === undefined ? "" : contribuyente?.curp.toUpperCase()}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, curp: e.target.value.toUpperCase() } })}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* ... Separador ... */}
            <div className="boxRow divider"><div></div></div>

            {/* Pestañas: Contacto, Domicilio, Observaciones */}
            <div className="contenedor-nav boxRow noGap">
                <div>
                    <span className="espacio"></span>
                    <Link to="/contacto/contacto"><button className={`tablinks boton-tab tab ${path === "/contacto/contacto" && "active"}`}>Contacto</button></Link>
                    <Link to="/contacto/domicilio"><button className={`tablinks boton-tab tab ${path === "/contacto/domicilio" && "active"}`}>Domicilio</button></Link>
                    <Link to="/contacto/observaciones"><button className={`tablinks boton-tab tab ${path === "/contacto/observaciones" && "active"}`}>Observaciones</button></Link>
                    <span className="espacio"></span>
                </div>
            </div>

            {/* Modal */}
            {isModalOpen && <Modal onRequestClose={toggleModal} contribuyentes={contribuyentes} setData={setData} />}

            <Outlet />

        </div >
    );
}
